import React from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs"; 
import { useLang } from "../utils/LangContext";

const PublicGamesList = ({ publicGames }) => {
    const { t } = useLang();

    return (
        <div className="cur-events-tbl">
            <h2>{t('Current Public Games')}</h2>
            {publicGames && publicGames.length > 0 ? (
                <div>
                    {publicGames.map((publicGame, index) => (
                        
                        <div key={index} className="public-game-item">
                            

                            <h3>{publicGame.name}</h3>
                            <div>{dayjs(publicGame.start).format("DD.MM.YYYY HH:mm")} - {dayjs(publicGame.end).format("DD.MM.YYYY HH:mm")}</div>
                            <p>{publicGame.hostName + ' (Tel: ' + publicGame.hostTel + ')'}</p>
                            <div className="d-flex justify-content-end">
                                <Link to={`/public-game/${publicGame.hash}`} className="btn btn-primary me-2 eventBtn">{t('Create/Join Team')}</Link>
                                <Link to={`/leaderboard/${publicGame.hash}`} className="btn btn-primary me-2 eventBtn">{t('Leaderboard')}</Link>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <p>{t('No active public games available')}</p>
            )}
        </div>
    );
};

export default PublicGamesList;
